import type { FaireProductEntity } from "../../entity_types/product";

export const p_kq3hkffnvh: FaireProductEntity = {
  token: "p_kq3hkffnvh",
  type: "product",
  name: "Organic Extra Virgin Olive Oil - 500mL",
  brandToken: "b_8h4l3mg9te",
  brandName: "Bari Olive Oil",
  imageUrl:
    "https://cdn.faire.com/fastly/a0ca6b35b1fe80777071c0c01571b1698b409c8ae5efaf3d4ce8dbc2da79cfdc.png",
  galleryImageUrls: [],
  priceDollars: 18.01,
  description:
    "Certified Organic California Extra Virgin Olive Oil with a grassy flavor and peppery finish. It's non-GMO. It's COOC-Certified. It's Kosher. It's a perfect addition to your famliy's table. All our Arbequina olives are locally-sourced from groves in the heart of California in small batches to ensure olives are milled within twenty-four hours of harvest. In addition, our olive oil is always unfiltered. We use a natural racking process to provide you the highest quality olive oil possible. Ordering in bulk? Our shipping boxes hold six (6) bottles each.",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:55.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
